import { LotActions, LotActionTypes } from './lot.actions';
import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ILotCommon, ILotTable, selectUnitId } from './lot.interfaces';

export const lotAdapter: EntityAdapter<ILotCommon> = createEntityAdapter<ILotCommon>({
  selectId: selectUnitId
});

export function lotInitState(): ILotTable {
  return lotAdapter.getInitialState({
    selectedUnitId: null
  });
}

export function lotReducer(state = lotInitState(), action: LotActions) {
  switch (action.type) {
    case LotActionTypes.SET_UNIT_ID:
      return {
        ...state,
        selectedUnitId: action.payload
      };
    case LotActionTypes.FETCH_LOT_DETAILS_SUCCESS:
      return lotAdapter.addOne(action.payload, state);
    case LotActionTypes.SAVE_LOT_SUCCESS:
      return lotAdapter.setOne(action.payload, state);
    case LotActionTypes.REMOVE_ALL_LOTS:
      return lotAdapter.removeAll(state);
  default:
    return state;
  }
}
